(() => {
  const menus = document.querySelectorAll('[data-products-mega]');

  menus.forEach((menu) => {
    const trigger = menu.querySelector('[data-products-mega-trigger]');
    const panel = menu.querySelector('[data-products-mega-panel]');
    const globalHeader = document.getElementById('globalHeader');
    if (!trigger || !panel) return;

    const close = () => {
      menu.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      globalHeader?.classList.remove('is-mega-open');
    };

    const open = () => {
      menu.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      globalHeader?.classList.add('is-mega-open');
    };

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      menu.classList.contains('is-open') ? close() : open();
    });

    panel.addEventListener('click', (event) => event.stopPropagation());
    document.addEventListener('click', close);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        trigger.focus();
      }
    });

    window.addEventListener('resize', close);
  });
})();
